import LoginView from './Login.vue'
import OfflineView from './Offline.vue'
import PageNotFoundView from './404.vue'

export const Login = LoginView
export const Offline = OfflineView
export const PageNotFound = PageNotFoundView
